import { Download } from "../../../helpers/download";
import { NotifyHelper } from "../../../helpers/toast";
import { eReportActionsObj } from "../../action-types/report/IReportActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const reportActions = {
  ...generateActions(eReportActionsObj, "REPORT"),
  ...generateActionForKey(
    eReportActionsObj,
    "REPORT",
    "EXPORT_EXCEL_BAO_CAO_SUCCESS",
    (data: any) => {
      Download.Excel(data, "bao_cao_theo_ky.xlsx");
      NotifyHelper.Success("Thành công!");
    }
  ),
  ...generateActionForKey(
    eReportActionsObj,
    "REPORT",
    "EXPORT_EXCEL_BAO_CAO_ERRR",
    (m: any) => {
      NotifyHelper.Error(m);
    }
  ),
};
